module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workspace', [_c('div', {
    attrs: {
      "slot": "form"
    },
    slot: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "headline"
    }
  }, [_vm._v("Headline")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.headline),
      expression: "headline"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "headline"
    },
    domProps: {
      "value": (_vm.headline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.headline = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "subhead"
    }
  }, [_vm._v("Subhead")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subhead),
      expression: "subhead"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "subhead"
    },
    domProps: {
      "value": (_vm.subhead)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subhead = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "body"
    }
  }, [_vm._v("Body")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body),
      expression: "body"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "id": "body"
    },
    domProps: {
      "value": (_vm.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.body = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "link"
    }
  }, [_vm._v("Callout")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callout),
      expression: "callout"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "textarea",
      "id": "callout"
    },
    domProps: {
      "value": (_vm.callout)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callout = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "buttonText"
    }
  }, [_vm._v("Button Text")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buttonText),
      expression: "buttonText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "buttonText"
    },
    domProps: {
      "value": (_vm.buttonText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.buttonText = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "link"
    }
  }, [_vm._v("Button Link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link),
      expression: "link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "link"
    },
    domProps: {
      "value": (_vm.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" Reset")]), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyHtml",
      "aria-label": "Copied HTML!"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy HTML")]), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "id": "copyTextVersion",
      "data-component": _vm.currentTemplate,
      "aria-label": "Copied Text!"
    },
    on: {
      "click": _vm.copyTextVersion
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy text")])])])]), _c('table', {
    attrs: {
      "slot": "render",
      "align": "center",
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    },
    slot: "render"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "line-height": "0px",
      "font-size": "0px",
      "mso-line-height-rule": "exactly"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center",
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "role": "presentation"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "direction": "ltr",
      "font-size": "0px",
      "padding": "0",
      "text-align": "center",
      "vertical-align": "top"
    }
  }, [_c('table', {
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "role": "presentation",
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top",
      "width": "400px"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "role": "presentation",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border": "3px solid #22528e",
      "vertical-align": "top",
      "padding": "20px 32px",
      "background-color": "#ffffff"
    }
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "role": "presentation",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "font-size": "0px",
      "padding": "10px 25px",
      "word-break": "break-word"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "font-size": "34px",
      "font-weight": "bold",
      "line-height": "42px",
      "text-align": "center",
      "color": "#22528e"
    }
  }, [_vm._v(_vm._s(_vm.headline))])])]), (_vm.subhead) ? _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "0px",
      "padding": "10px 25px",
      "word-break": "break-word"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "font-size": "21px",
      "font-weight": "normal",
      "line-height": "30px",
      "text-align": "center",
      "color": "#22528e"
    }
  }, [_vm._v(_vm._s(_vm.subhead))])])]) : _vm._e(), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "0px",
      "padding": "10px 25px",
      "word-break": "break-word"
    },
    attrs: {
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "font-size": "15px",
      "line-height": "22px",
      "text-align": "left",
      "color": "#686D75"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.bodyText)
    }
  })])]), (_vm.callout) ? _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "0px",
      "padding": "10px 25px",
      "word-break": "break-word"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-family": "Helvetica, Arial, sans-serif",
      "font-size": "21px",
      "line-height": "30px",
      "text-align": "center",
      "color": "#686D75"
    }
  }, [_vm._v(_vm._s(_vm.callout))])])]) : _vm._e(), _c('tr', [_c('td', {
    staticStyle: {
      "font-size": "0px",
      "padding": "10px 25px",
      "word-break": "break-word"
    },
    attrs: {
      "align": "center",
      "vertical-align": "middle"
    }
  }, [_c('table', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "role": "presentation",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "body-text",
    staticStyle: {
      "font-size": "0px",
      "padding": "10px 25px",
      "word-break": "break-word"
    },
    attrs: {
      "align": "center",
      "vertical-align": "middle"
    }
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "separate",
      "line-height": "100%"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "role": "presentation"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none",
      "border-radius": "4px",
      "cursor": "auto",
      "padding": "10px 35px",
      "background": "#22528e",
      "color": "#ffffff"
    },
    attrs: {
      "align": "center",
      "bgcolor": "#22528e",
      "role": "presentation",
      "valign": "middle"
    }
  }, [_c('a', {
    staticStyle: {
      "background": "#22528e",
      "color": "#ffffff",
      "font-family": "Helvetica, Arial, sans-serif",
      "font-size": "18px",
      "font-weight": "normal",
      "line-height": "120%",
      "Margin": "0",
      "text-decoration": "none",
      "text-transform": "none"
    },
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])])])])]), _vm._v("-->"), _vm._v("-->")])])])])])])])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f39b2160"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-do/note.vue
// module id = 232
// module chunks = 0